import { useState } from "react";

const roles = [
  { value: "ADMIN", label: "Админ" },
  { value: "FINANCIER", label: "Финансист" },
  { value: "DIRECTOR", label: "Директор" },
  { value: "ACCOUNTANT", label: "Бухгалтер" }
];

export default function UsersPage({
  users,
  currentUser,
  addUser,
  updateUserRole,
  deleteUser
}) {
  const [name, setName] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState("ACCOUNTANT");
  const [editedUsers, setEditedUsers] = useState({});

  const createUser = () => {
    if (!name.trim() || !username.trim() || !password.trim()) {
      return;
    }

    addUser(name.trim(), role, username.trim(), password);
    setName("");
    setUsername("");
    setPassword("");
    setRole("ACCOUNTANT");
  };

  const updateEditedUser = (userId, field, value) => {
    setEditedUsers((current) => ({
      ...current,
      [userId]: {
        username: users.find((user) => user.id === userId)?.username || "",
        password: "",
        ...current[userId],
        [field]: value
      }
    }));
  };

  const saveCredentials = (user) => {
    const edited = editedUsers[user.id] || {};
    const nextUsername = edited.username ?? user.username;
    const nextPassword = edited.password ?? "";

    updateUserRole(user.id, user.role, nextUsername, nextPassword);
    setEditedUsers((current) => ({
      ...current,
      [user.id]: {
        username: nextUsername,
        password: ""
      }
    }));
  };

  return (
    <div>
      <h1>Пользователи и роли</h1>

      <div className="users-create">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="Имя пользователя"
        />

        <input
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          placeholder="Username"
        />

        <input
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Password"
          type="password"
        />

        <select value={role} onChange={(e) => setRole(e.target.value)}>
          {roles.map((item) => (
            <option key={item.value} value={item.value}>{item.label}</option>
          ))}
        </select>

        <button onClick={createUser}>Создать пользователя</button>
      </div>

      <div className="users-list">
        {users.map((user) => (
          <div className="user-row" key={user.id}>
            <div className="user-title">
              <strong>{user.name}</strong>
              <span>{user.username || "username не задан"}</span>
            </div>

            <input
              value={editedUsers[user.id]?.username ?? user.username ?? ""}
              onChange={(e) => updateEditedUser(user.id, "username", e.target.value)}
              placeholder="Username"
            />

            <input
              value={editedUsers[user.id]?.password ?? ""}
              onChange={(e) => updateEditedUser(user.id, "password", e.target.value)}
              placeholder="Новый пароль"
              type="password"
            />

            <select
              value={user.role}
              onChange={(e) => updateUserRole(user.id, e.target.value)}
            >
              {roles.map((item) => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))}
            </select>

            <button onClick={() => saveCredentials(user)}>
              Сохранить
            </button>

            <button
              className="user-delete-btn"
              disabled={user.id === currentUser?.id}
              title={user.id === currentUser?.id ? "Нельзя удалить текущего пользователя" : "Удалить пользователя"}
              onClick={() => deleteUser(user.id)}
            >
              &#128465;
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
